module.exports = __webpack_public_path__ + "img/logo-header.a79ae34b.png";